module.exports = __webpack_public_path__ + "img/one_logo_black.c321cc33.png";